import React from "react";
import { TableFilterClub } from "../../common/enums/common.enums";

interface ITableClubContext {
  tab: string;
  changeTab: (tab: TableFilterClub) => void;
}

export const useTableClubContext = React.createContext({} as ITableClubContext);
